/* eslint-disable react/jsx-props-no-spreading */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Price } from '@thd-olt-component-react/price';
import { Typography, SkeletonBlock } from '@one-thd/sui-atomic-components';
import { extend, QueryContext } from '@thd-nucleus/data-sources';
import { useBundlePricingDetails, getBundleWithPricing } from '@thd-olt-component-react/product-bundle';
import { getTotalPriceText, getTotalItems, getPlaceholderHeight } from '../utils/product-utils';

const BundleMiniPrice = ({
  product, products, bundleId, hideUnitOfMeasure, multiParent
}) => {
  const experienceContext = useContext(ExperienceContext);
  const { channel } = experienceContext || {};
  const { features } = product || {};
  const totalItems = getTotalItems(products);
  const { defaultVariables } = useContext(QueryContext);
  const placeHolderHeight = getPlaceholderHeight(channel, multiParent);

  const { pricing } = useBundlePricingDetails({
    product,
    products,
    loading: false,
    isCustomerIdentified: defaultVariables?.current?.isBrandPricingPolicyCompliant
  });

  if (!pricing) {
    return <SkeletonBlock aspect="wide" height={placeHolderHeight} />;
  }

  const propProductData = getBundleWithPricing({
    bundle: product,
    pricing: {
      ...pricing,
      unitOfMeasure: hideUnitOfMeasure ? '' : pricing?.unitOfMeasure
    }
  });

  return (
    <div data-testid="bundle-mini-price">
      <div className="sui-mb-2">
        <Typography variant="body-base" height="tight">
          Total price for {totalItems} {getTotalPriceText(products, features)}
        </Typography>
      </div>
      <div className="sui-flex sui-gap-2">
        <Price
          product={propProductData}
          itemId={bundleId}
          type={multiParent && channel === 'mobile' ? 'simple' : ''}
        />
      </div>
    </div>
  );
};

BundleMiniPrice.propTypes = {
  product: PropTypes.shape({
    itemId: PropTypes.string,
    bundleSpecificationDetails: PropTypes.shape({
      experienceType: PropTypes.string,
      type: PropTypes.string
    })
  }),
  products: PropTypes.arrayOf(PropTypes.shape({
    pricing: PropTypes.shape()
  })),
  bundleId: PropTypes.string.isRequired,
  hideUnitOfMeasure: PropTypes.bool,
  multiParent: PropTypes.bool
};

BundleMiniPrice.defaultProps = {
  product: {},
  products: [],
  hideUnitOfMeasure: false,
  multiParent: false
};

BundleMiniPrice.displayName = 'BundleMiniPrice';

BundleMiniPrice.dataModel = extend(Price);

export { BundleMiniPrice };